module.exports = "/_next/static/images/apple-touch-icon-180-b8ee617aa88e19dfc892557576cbcdf1.png";